export type TextTrack = {
    id: string,
    lang: string,
    label: string,
    kind: string,
    //defaultTrack: boolean,
    isActive: boolean
};

export const EmptyTextTrack: TextTrack = { id: "", label: "", kind: "", lang: "", isActive: false };